import React, { useReducer } from 'react';
import ProspectoContext from './prospectoContext';
import ProspectoReducer from './prospectoReducer';
import clienteAxios from '../../../config/axios';
import swal from 'sweetalert2';

import { 
    INIT_REGISTRO_PROSPECTO,   
    REGISTRO_PROSPECTO_EXITOSO,
    REGISTRO_PROSPECTO_ERROR,
    INIT_OBTENER_PROSPECTO_EMPRESAPERTENECE,
    OBTENER_PROSPECTO_EMPRESASPERTENECE_EXITOSO,
    OBTENER_PROSPECTO_EMPRESASPERTENECE_ERROR,
    INIT_OBTENER_PROSPECTOS,
    OBTENER_PROSPECTOS_EXITOSO,
    OBTENER_PROSPECTOS_ERROR
 } from '../../../types';

const ProspectoState = ( props ) => {

    const initialState = {
        prospectos: null,
        entidadesPadre: null,
        cargando: false,
        error: null,
        requests: 0
    }

    const [ state, dispatch ] = useReducer( ProspectoReducer, initialState );

    const obtenerEmpresas = async ( data ) => {
        dispatch( initObtenerEmpresas() );
        
        try {
            const respuesta = await clienteAxios.get( `/contactos/empresaspertenece/${data}` );
            
            if( respuesta.data ){
                dispatch( obtenerEmpresasExitoso( respuesta.data ) );
            }else{
                dispatch( obtenerEmpresasError( null ) );
            }

            return respuesta.data;
        } catch ( error ) {
            console.log( error );
            dispatch( obtenerEmpresasError( error ) );
        }
    }

    const obtenerProspectos = async ( id, data ) => {
        dispatch( initObtenerProspectos() );
        
        try {

            const respuesta = await clienteAxios.get( `/contactos/clientesLimed/${id}/${data}` );

            if( respuesta.data ){

                dispatch( obtenerProspectosExitoso( respuesta.data ) );
            }else{
                dispatch( obtenerProspectosExitoso( null ) );
            }
        } catch ( error ) {
            console.log( error );
            dispatch( obtenerProspectosError( error ) );
        }
    }

    const guardarProspecto = async ( data ) => {
        dispatch( initRegistroProspecto() );

        try {

            const response = await clienteAxios.post( '/contactos', data );

            if( response.data ){

                dispatch( registroProspectoExitoso( response.data ) );
                swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'El cliente ha sido registrado correctamente',
                    showConfirmButton: false,
                    timer: 2000
                });

                window.location.reload(false);
            }else{
                dispatch( registroProspectoExitoso( null ) );
                swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'El cliente no pudo ser registrado',
                });
            }
        } catch ( error ) {
            console.log( error.response );
            let e = Array.isArray( error.response.data.mensaje ) ? error.response.data.mensaje[0].msg : error.response.data.mensaje;
            dispatch( registroProspectoError( e ) );
            swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Error al registrar cliente. ${e}`,
            });
        }
    }

    const initRegistroProspecto = () => ( { type: INIT_REGISTRO_PROSPECTO } );

    const registroProspectoExitoso = ( data ) => ( { type: REGISTRO_PROSPECTO_EXITOSO, payload: data } );

    const registroProspectoError = ( error ) => ( { type: REGISTRO_PROSPECTO_ERROR, payload: error } );

    const initObtenerEmpresas = () => ( { type: INIT_OBTENER_PROSPECTO_EMPRESAPERTENECE } );

    const obtenerEmpresasExitoso = ( data ) => ( { type: OBTENER_PROSPECTO_EMPRESASPERTENECE_EXITOSO, payload: data } );

    const obtenerEmpresasError = ( error ) => ( { type: OBTENER_PROSPECTO_EMPRESASPERTENECE_ERROR, payload: error } );

    const initObtenerProspectos = () => ( { type: INIT_OBTENER_PROSPECTOS } );

    const obtenerProspectosExitoso = ( data ) => ( { type: OBTENER_PROSPECTOS_EXITOSO, payload: data } );

    const obtenerProspectosError = ( error ) => ( { type: OBTENER_PROSPECTOS_ERROR, payload: error } );

    return ( 
        <ProspectoContext.Provider
            value={{
                prospectos: state.prospectos,
                entidadesPadre: state.entidadesPadre,
                cargando: state.cargando,
                error: state.error,
                requests: state.requests,
                obtenerEmpresas,
                guardarProspecto,
                obtenerProspectos
            }}
        >
            {props.children}
        </ProspectoContext.Provider>
     );
}
 
export default ProspectoState;